<ng-container *ngIf="installationDetailsStore.getGatewayStatus() | async as gatewayStatus">
  <app-offline-device
    *ngIf="
      !(gatewayStore.isSingleRoomControlAvailable$ | async) && gatewayStatus?.offline;
      else isNotOffline
    "
  >
  </app-offline-device>

  <ng-template #isNotOffline>
    <div class="main flex flex-col gap-[24px]" *ngIf="!(areResults$ | async)">
      <h2 data-at-comissioning-start-overview>
        {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.START_OVERVIEW.TITLE' | translate }}
      </h2>

      <div class="flex gt-sm:flex-row lt-md:flex-col gap-[16px]">
        <app-jumbotron
          class="flex flex-col gap-[24px] lt-md:gap-[16px] flex-[100%] lt-md:flex-auto"
        >
          <h3>
            {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM' | translate }}
          </h3>
          <vi-text>
            {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM_DESCRIPTION' | translate }}
          </vi-text>
          <div>
            <button
              data-at-comissioning-btn-add-room-overview
              mat-raised-button
              color="primary"
              gtm="onOpen"
              gtmAction="Add room dialog"
              gtmCategory="commissioning"
              (click)="onAddRoom()"
            >
              <mat-icon>add</mat-icon>
              <span>{{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM' | translate }}</span>
            </button>
          </div>
        </app-jumbotron>
        <app-jumbotron
          class="flex flex-col gap-[24px] lt-md:gap-[16px] flex-[100%] lt-md:flex-auto"
        >
          <h3>
            {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE' | translate }}
          </h3>
          <vi-text>
            {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE_DESCRIPTION' | translate }}
          </vi-text>
          <div>
            <button
              data-at-comissioning-btn-add-device-overview
              mat-raised-button
              color="primary"
              gtm="onOpen"
              gtmAction="Add device dialog"
              gtmCategory="commissioning"
              (click)="onAddDevice()"
            >
              <mat-icon>add</mat-icon>
              <span>{{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE' | translate }}</span>
            </button>
          </div>
        </app-jumbotron>
      </div>

      <div
        class="!hidden gt-sm:!flex flex-row justify-center items-center w-full min-w-full h-full min-h-full"
      >
        <img src="assets/img/search-guy.svg" />
      </div>
    </div>

    <app-commissioning-overview *ngIf="areResults$ | async"></app-commissioning-overview>
  </ng-template>
</ng-container>
